import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map, take } from 'rxjs/operators';
import { PermisosService } from '../services/permisos.service';
import { RUTAS } from '@core/constants/rutas.constants';

export const permisoGuard = (permisoRequerido: string): CanActivateFn => {
  return () => {
    const permisosService = inject(PermisosService);
    const router = inject(Router);

    if (!permisoRequerido) {
      void router.navigate(['/acceso-denegado']);
      return false;
    }

    return permisosService.tienePermiso(permisoRequerido).pipe(
      take(1),
      map(tiene => {
        if (!tiene) {
          void router.navigate(['/acceso-denegado'], {
            queryParams: { permiso: permisoRequerido }
          });
          return false;
        }
        return true;
      })
    );
  };
};

export const algunPermisoGuard = (permisos: readonly string[]): CanActivateFn => {
  return () => {
    const permisosService = inject(PermisosService);
    const router = inject(Router);

    return permisosService.tieneAlgunPermiso([...permisos])
      ? true
      : router.createUrlTree([RUTAS.ACCESO_DENEGADO]);
  };
};
